import gql from "graphql-tag";

export {
  listOrgs,
  listUnitsByOrg,
  listQuestionTemplates,
  listSectionTemplates,
  listFormTemplates,
  getFormTemplatesByType,
  getFormTemplateByUId,
  getFormTemplateBySlugValue,
  fetchDataByZip,
  listDevicesByOrg,
  listAllDevices,
  listFormSubscribers,
  getFormSubscriberByEmail,
  listQuestionTemplatesBySlugValue,
  listFormTemplateActivities,
  listQuestionTemplateActivities,
  getInventoriesByTypeValue,
  getOrgInventories,
  getOrgInventoryBatches,
  getUnitInventories,
  getDeviceInventories,
  getDeviceInventoryBatches,
  getInventoryActivities,
  getInventoryReport,
  fetchMedication,
  searchGlobalAdvice,
  searchGlobalDiagnosis,
  searchGlobalMedication,
  searchGlobalService,
  listOrderSetByCreatedAt,
  getFormTemplateByUIdV2,
  searchQuestions
};

const searchQuestions = gql`
query searchQuestions( $typeValue: String! $searchValue: String! $limit: Int $nextToken: String){
  searchQuestions(typeValue: $typeValue searchValue: $searchValue limit: $limit nextToken: $nextToken){
    items{
      id
        typeValue
        slugValue
        questionTitle
        questionType
        helpText
        uId
        ageFrom
        ageTo
        appliedFor
        createdAt
        updatedAt
        helpText
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
        searchField
        radioDisplayType
    }
    nextToken
  }
}
# {
#   "typeValue": "global::question",
#   "searchValue": "anal swelling",
#   "limit": 10000,
#   "nextToken": ""
# }
`;


const listOrderSetByCreatedAt = gql`
query listOrderSetByCreatedAt($limit: Int $nextToken: String $stage: String){
  listOrderSetByCreatedAt(limit: $limit nextToken: $nextToken stage: $stage){
    items{
      id
      typeValue
      slugValue
      orderSetName
      searchField
      diagnosis
      advice
      procedure
      investigation
      note
      active
      ageGroup{
        ageFrom
        ageTo
        type
      } 
      appliedFor
      diagnosisMap{
        # id
        code
        name
      }
      medication{
        brandName
        genericName
        frequency
        dosage
        dosageUnit
        dosageDate
        roa
        instruction
        duration
      }
      investigationMap{
        id
        serviceCode
        serviceName
      }
      procedureMap{
        id
        serviceCode
        serviceName
      }
      adviceMap{
        id
        slugValue
        adviceName
      }
      createdAt
      updatedAt
      createdBy
      updatedBy
    }
    nextToken
  }
}
# {
#   "limit": 20,
#   "nextToken": ""
# }
`;

const searchGlobalService = gql`
query searchGlobalService( $searchValue: String! $from: Int! $size: Int!){
  searchGlobalService(searchValue: $searchValue from: $from size: $size){
    id
    serviceCode
    serviceName
  }
}
# {
#   "searchValue": "transplant",
#   "from": 0,
#   "size": 50
# }
`


const searchGlobalMedication = gql`
query searchGlobalMedication( $searchValue: String! $from: Int! $size: Int!){
  searchGlobalMedication(searchValue: $searchValue from: $from size: $size){
    id
    genericName
    medicationName
  }
}
# {
#   "searchValue": "thri",
#   "from": 0,
#   "size": 50
# }
`

const searchGlobalDiagnosis = gql`
query searchGlobalDiagnosis($searchValue: String! $from: Int! $size: Int!){
  searchGlobalDiagnosis(searchValue: $searchValue from: $from size: $size){
    id
    code
    name
  }
}
# {
#   "searchValue": "pain",
#   "from": 0,
#   "size": 50
# }
`

const searchGlobalAdvice = gql`
query searchGlobalAdvice( $searchValue: String! $from: Int! $size: Int!){
  searchGlobalAdvice(searchValue: $searchValue from: $from size: $size){
    id
    adviceName
  }
}
# {
#   "searchValue": "rest",
#   "from": 0,
#   "size": 50
# }
`

const fetchMedication = gql`
query fetchMedication( $searchValue: String! $from: Int! $size: Int!){ 
  fetchMedication(searchValue: $searchValue from: $from size: $size){
    id
    genericName
    medicationName
  }
}


# {
#   "searchValue": "parra",
#   "from": 0,
#   "size": 20
# }
`;

const getInventoriesByTypeValue  = gql`
query getInventoriesByTypeValue( $typeValue: String!){
  getInventoriesByTypeValue(typeValue: $typeValue){
     id
    typeValue
    code
    name
    description
    totalStock
    currentStock
    consumedStock
    adjustedStock
    createdAt
    updatedAt
    updatedBy
  }
}
# {
#   "typeValue": "global"
# }
`

const inventoryFields = `
  id
  typeValue
  code
  name
  unit
  description
  orgId
  unitId
  deviceId
  scope
  totalStock
  currentStock
  consumedStock
  adjustedStock
  allocatedStock
  lowStockThreshold
  createdAt
  updatedAt
  createdBy
  updatedBy
`;

const inventoryBatchFields = `
  id
  typeValue
  code
  itemCode
  itemName
  unit
  batchNumber
  expiryDate
  orgId
  unitId
  deviceId
  scope
  unitsPerPack
  totalStock
  currentStock
  availablePacks
  createdAt
  updatedAt
  createdBy
  updatedBy
`;

const inventoryActivityFields = `
  id
  typeValue
  code
  orgId
  unitId
  deviceId
  itemCode
  itemName
  qty
  consumedBy
  note
  batchNumber
  expiryDate
  packCount
  unitsPerPack
  type
  createdAt
  createdBy
`;

const getOrgInventories = gql`
query getOrgInventories($orgId: String, $limit: Int, $nextToken: String){
  getOrgInventories(orgId: $orgId, limit: $limit, nextToken: $nextToken){
    items{
      ${inventoryFields}
    }
    nextToken
  }
}
`;

const getOrgInventoryBatches = gql`
query getOrgInventoryBatches($orgId: String, $code: String!, $limit: Int, $nextToken: String){
  getOrgInventoryBatches(orgId: $orgId, code: $code, limit: $limit, nextToken: $nextToken){
    items{
      ${inventoryBatchFields}
    }
    nextToken
  }
}
`;

const getUnitInventories = gql`
query getUnitInventories($orgId: String, $unitId: String!, $limit: Int, $nextToken: String){
  getUnitInventories(orgId: $orgId, unitId: $unitId, limit: $limit, nextToken: $nextToken){
    items{
      ${inventoryFields}
    }
    nextToken
  }
}
`;

const getDeviceInventories = gql`
query getDeviceInventories($orgId: String, $unitId: String, $deviceId: String!, $limit: Int, $nextToken: String){
  getDeviceInventories(orgId: $orgId, unitId: $unitId, deviceId: $deviceId, limit: $limit, nextToken: $nextToken){
    items{
      ${inventoryFields}
    }
    nextToken
  }
}
`;

const getDeviceInventoryBatches = gql`
query getDeviceInventoryBatches($orgId: String, $unitId: String, $deviceId: String!, $code: String!, $limit: Int, $nextToken: String){
  getDeviceInventoryBatches(orgId: $orgId, unitId: $unitId, deviceId: $deviceId, code: $code, limit: $limit, nextToken: $nextToken){
    items{
      ${inventoryBatchFields}
    }
    nextToken
  }
}
`;

const getInventoryActivities = gql`
query getInventoryActivities($scope: String!, $orgId: String, $unitId: String, $deviceId: String, $limit: Int, $nextToken: String){
  getInventoryActivities(scope: $scope, orgId: $orgId, unitId: $unitId, deviceId: $deviceId, limit: $limit, nextToken: $nextToken){
    items{
      ${inventoryActivityFields}
    }
    nextToken
  }
}
`;

const getInventoryReport = gql`
query getInventoryReport($orgId: String, $unitId: String, $deviceId: String){
  getInventoryReport(orgId: $orgId, unitId: $unitId, deviceId: $deviceId){
    orgId
    unitId
    deviceId
    scope
    itemsCount
    totalStock
    currentStock
    consumedStock
    adjustedStock
    allocatedStock
    lowStockItems
    inventories{
      ${inventoryFields}
    }
    adjustmentHistory{
      ${inventoryActivityFields}
    }
  }
}
`;

const listQuestionTemplateActivities = gql`
query{
  listQuestionTemplateActivities(limit: 20, nextToken:""){
    items{
      id
      typeValue
      slugValue
      activityType
      uId
      createdAt
      createdBy
      originalQuestion{
        # id
        typeValue
        slugValue
        questionTitle
        questionType
        helpText
        uId
        ageFrom
        ageTo
        appliedFor
        createdAt
        updatedAt
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
        radioDisplayType
      }
    }
    nextToken
  }
}`


const listFormTemplateActivities = gql`
query{
  listFormTemplateActivities(limit: 20 nextToken: ""){
    items{
      id
      typeValue
      slugValue
      activityType
      uId
      createdAt
      createdBy
      originalFormTemplate{
        # id
    uId
    typeValue
    slugValue
    templateName
    displayName
    templateType
    displayName
    subTemplate
    # questionRefs
    keywords
    speciality
    subSpeciality
    templateDesignJson
    templateRows{
      title
	    addColumns
	    templateColumns{
        title
        addSection
        columnSections{
          title
          isEditing
          secQuestions{
            slugValue
	          queConditions{
              key
              conditonValue{
                quesSlug
	              response
              }
              childrens{
                key
	              conditonValue{
                  quesSlug
                  response
                }
              }
            }
          }
        }
      }
    }
      active
      createdAt
      updatedAt
      createdBy
      updatedBy
      # uId
      attachedQuestionRefs {
        # id
        typeValue
        slugValue
        questionTitle
        questionType
        helpText
        uId
        ageFrom
        ageTo
        appliedFor
        createdAt
        updatedAt
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
        radioDisplayType
      }
      }
    }
    nextToken
  }
}`


const listQuestionTemplatesBySlugValue = gql`
query listQuestionTemplatesBySlugValue($subscriberId: String! $slugValue: String!){
  listQuestionTemplatesBySlugValue(subscriberId: $subscriberId slugValue: $slugValue){
    id
        typeValue
        slugValue
        questionTitle
        questionType
        helpText
        uId
        ageFrom
        ageTo
        appliedFor
        createdAt
        updatedAt
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
        radioDisplayType
  }
}
# {
#   "subscriberId": "TE00003",
#   "slugValue": "abc"
# }
# {
#   "subscriberId": "global",
#   "slugValue": "abc"
# }
`

const getFormSubscriberByEmail = gql`
query getFormSubscriberByEmail( $typeValue: String! $email: String!){
  getFormSubscriberByEmail(typeValue: $typeValue email: $email){
      typeValue
      email
      mobile
      contactName
      countryCode
      orgName
      gstNo
      noOfTemplates
      expiryDate
      enabled
      createdAt
      updatedAt
      subscriberId
      apiKey
      callbackUrl
      address{
        use
        type
        lineOne
        lineTwo
        city
        state
        zip
        country
      }
    }
}
# {
#   "typeValue": "subscriber",
#   "email": "sohel.khan@clinivantage.com"
# }
`

const listFormSubscribers = gql`
query listFormSubscribers( $typeValue: String! $limit: Int $nextToken: String){
  listFormSubscribers(typeValue: $typeValue limit: $limit nextToken: $nextToken){
    items{
      id
      typeValue
      email
      mobile
      contactName
      countryCode
      orgName
      gstNo
      noOfTemplates
      expiryDate
      enabled
      createdAt
      updatedAt
      subscriberId
      apiKey
      datasetEnabled
      address{
        use
        type
        lineOne
        lineTwo
        city
        state
        zip
        country
      }
    }
  }
}
# {
#   "typeValue": "subscriber",
#   "limit": 20,
#   "nextToken": ""
# }
`

const listAllDevices = gql`
  query listAllDevices($limit: Int, $nextToken: String) {
    listAllDevices(limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgId
        deviceId
        physicalId
        deployedAt
        active
        deviceType
        channelId
        platform
        system
        hospitalId
        assignedDevices {
          deviceName
          serialNumber
          deviceType
        }
        categories {
          category
          active
          tests {
            text
            deviceName
            value
            rate
            refImage{
              bucket
              region
              key
            }
            url {
              bucket
              region
              key
            }
            enabled
            active
          }
        }
      }
      nextToken
    }
  }
  # {
  #   "limit": 10,
  #   "nextToken": ""
  # }
`;

const listOrgs = gql`
  query listOrgs($limit: Int, $nextToken: String) {
    listOrgs(limit: $limit, nextToken: $nextToken) {
      items {
        id
        fqdn
        unitId
        orgName
        email
        contactNo
        type
        isActive
        address {
          use
          type
          lineOne
          lineTwo
          city
          state
          zip
          country
        }
      }
      nextToken
    }
  }
  #{
  #  "limit": 20,
  # "nextToken": ""
  #}
`;

const fetchDataByZip = gql`
  query fetchDataByZip($country: CountryCode!, $zip: String!) {
    fetchDataByZip(country: $country, zip: $zip) {
      zip
      city
      state
      country
    }
  }
  # {
  #   "country": "IND",
  #   "zip": "411033"
  # }
`;

const getFormTemplateBySlugValue = gql`
query getFormTemplateBySlugValue($typeValue: String! $slugValue: String!){
  getFormTemplateBySlugValue(typeValue: $typeValue slugValue: $slugValue){
    # id
    uId
    typeValue
    slugValue
    templateName
    displayName
    templateType
    displayName
    subTemplate
    questionRefs
    keywords
    speciality
    subSpeciality
    templateDesignJson
    customVariables
    templateRows{
      title
	    addColumns
	    templateColumns{
        title
        addSection
        columnSections{
          title
          isEditing
          secQuestions{
            slugValue
	          queConditions{
              key
              conditonValue{
                quesSlug
	              response
              }
              childrens{
                key
	              conditonValue{
                  quesSlug
                  response
                }
              }
            }
          }
        }
      }
    }
      active
      createdAt
      updatedAt
      createdBy
      updatedBy
      attachedSubtemplateRef {
          # id
    uId
    typeValue
    slugValue
    templateName
    displayName
    templateType
    displayName
    subTemplate
    questionRefs
    keywords
    speciality
    subSpeciality
    templateDesignJson
    customVariables
    templateRows{
      title
	    addColumns
	    templateColumns{
        title
        addSection
        columnSections{
          title
          isEditing
          secQuestions{
            slugValue
	          queConditions{
              key
              conditonValue{
                quesSlug
	              response
              }
              childrens{
                key
	              conditonValue{
                  quesSlug
                  response
                }
              }
            }
          }
        }
      }
    }
      active
      createdAt
      updatedAt
      createdBy
      updatedBy
    
      # uId
      attachedQuestionRefs {
        # id
        typeValue
        slugValue
        questionTitle
        questionType
        helpText
        uId
        ageFrom
        ageTo 
        addNote
        addNotApplicable 
        addPainCalculation
        allowToPrint
        selectedPainQue
        appliedFor
        createdAt
        updatedAt
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
      }
      }
      # uId
      attachedQuestionRefs {
        # id
        typeValue
        slugValue
        questionTitle
        questionType
        helpText
        uId
        ageFrom
        ageTo   
        addNote
        addNotApplicable 
        addPainCalculation
        allowToPrint
        selectedPainQue
        appliedFor
        createdAt
        updatedAt
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
        radioDisplayType
      }
}
}
# {
#   "typeValue": "global::template",
#   "slugValue": "my-form"
# }
`;


const getFormTemplateByUIdV2 = gql`
  query getFormTemplateByUId($uId: String!) {
    getFormTemplateByUId(uId: $uId) {
      # id
      uId
    typeValue
    slugValue
    templateName
    displayName
    templateDesignJson
    templateRows{
      title
	    addColumns
	    templateColumns{
        title
        addSection
        columnSections{
          title
          isEditing
          secQuestions{
            slugValue
	          queConditions{
              key
              conditonValue{
                quesSlug
	              response
              }
              childrens{
                key
	              conditonValue{
                  quesSlug
                  response
                }
              }
            }
          }
        }
      }
    }
      active
      createdAt
      updatedAt
      createdBy
      updatedBy
    
  }
  }
  # {
  #   "uId": "ec533996-3102-4a1a-9cca-292b062ec7bc"
  # }
`;


const getFormTemplateByUId = gql`
  query getFormTemplateByUId($uId: String!) {
    getFormTemplateByUId(uId: $uId) {
      # id
      uId
    typeValue
    slugValue
    templateName
    displayName
    templateType
    displayName
    subTemplate
    questionRefs
    keywords
    speciality
    subSpeciality
    templateDesignJson
    customVariables
    templateRows{
      title
	    addColumns
	    templateColumns{
        title
        addSection
        columnSections{
          title
          isEditing
          secQuestions{
            slugValue
	          queConditions{
              key
              conditonValue{
                quesSlug
	              response
              }
              childrens{
                key
	              conditonValue{
                  quesSlug
                  response
                }
              }
            }
          }
        }
      }
    }
      active
      createdAt
      updatedAt
      createdBy
      updatedBy
      attachedSubtemplateRef{
          # id
      uId
    typeValue
    slugValue
    templateName
    displayName
    templateType
    displayName
    subTemplate
    questionRefs
    keywords
    speciality
    subSpeciality
    templateDesignJson
    customVariables
    templateRows{
      title
	    addColumns
	    templateColumns{
        title
        addSection
        columnSections{
          title
          isEditing
          secQuestions{
            slugValue
	          queConditions{
              key
              conditonValue{
                quesSlug
	              response
              }
              childrens{
                key
	              conditonValue{
                  quesSlug
                  response
                }
              }
            }
          }
        }
      }
    }
      active
      createdAt
      updatedAt
      createdBy
      updatedBy
      # uId
      attachedQuestionRefs {
        # id
        typeValue
        slugValue
        questionTitle
        questionType
        helpText
        uId
        ageFrom
        ageTo   
        addNote
        addNotApplicable
        addPainCalculation
        allowToPrint
        selectedPainQue
        appliedFor
        createdAt
        updatedAt
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
      }
      }
      # uId
      attachedQuestionRefs {
        # id
        typeValue
        slugValue
        questionTitle
        questionType
        helpText
        uId
        ageFrom
        ageTo
        addNote
        addNotApplicable
        addPainCalculation
        allowToPrint
        selectedPainQue
        appliedFor
        createdAt
        updatedAt
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
        radioDisplayType
      }
}
  }
  # {
  #   "uId": "ec533996-3102-4a1a-9cca-292b062ec7bc"
  # }
`;

const getFormTemplatesByType = gql`
  query getFormTemplatesByType($typeValue: String!, $templateType: String!) {
    getFormTemplatesByType(typeValue: $typeValue, templateType: $templateType) {
      id
    uId
    typeValue
    slugValue
    templateName
    displayName
    templateType
    displayName
    subTemplate
    questionRefs
    keywords
    speciality
    subSpeciality
    templateDesignJson
    templateRows{
      title
	    addColumns
	    templateColumns{
        title
        addSection
        columnSections{
          title
          isEditing
          secQuestions{
            slugValue
	          queConditions{
              key
              conditonValue{
                quesSlug
	              response
              }
              childrens{
                key
	              conditonValue{
                  quesSlug
                  response
                }
              }
            }
          }
        }
      }
    }
      active
      createdAt
      updatedAt
      createdBy
      updatedBy
      # uId
      attachedQuestionRefs {
        id
        typeValue
        slugValue
        questionTitle
        questionType
        helpText
        uId
        ageFrom
        ageTo
        appliedFor
        createdAt
        updatedAt
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
        radioDisplayType
      }
    }
  }
  # {
  #   "typeValue": "global::template",
  #   "templateType": "Complaint"
  # }
`;

// const listFormTemplates = gql`
//   query listFormTemplates($typeValue: String!) {
//     listFormTemplates(typeValue: $typeValue) {
//       id
//       typeValue
//       slugValue
//       templateName
//       templateType
//       subTemplate
//       questionRefs
//       speciality
//       subSpeciality
//templateDesignJson
//       templateRows {
//         title
//         addColumns
//         templateColumns {
//           title
//           addColumns
//           templateColumns {
//             title
//             addSection
//             columnSections {
//               title
//               isEditing
//               secQuestions {
//                 slugValue
//                 queConditions {
//                   key
//                   conditonValue {
//                     quesSlug
//                     response
//                   }
//                   childrens {
//                     key
//                     conditonValue {
//                       quesSlug
//                       response
//                     }
//                   }
//                 }
//               }
//             }
//           }
//         }
//         active
//         createdAt
//         updatedAt
//         createdBy
//         updatedBy
//         # uId
//         attachedQuestionRefs {
//           id
//           typeValue
//           slugValue
//           questionTitle
//           questionType
//           uId
//           ageFrom
//           ageTo
//           appliedFor
//           createdAt
//           updatedAt
//           active
//           isRequired
//           freeText {
//             answerSummary
//             freeTextRequired
//           }
//           number {
//             answerSummary
//             freeTextRequired
//           }
//           date {
//             answerSummary
//             freeTextRequired
//           }
//           file {
//             answerSummary
//             freeTextRequired
//           }
//           radioList {
//             optionTitle
//             optionSummary
//             freeTextRequired
//           }
//           checkboxList {
//             optionTitle
//             optionSummary
//             freeTextRequired
//           }
          // fillInBlanks{ 
          //   answerSummary  
          // } 
//           refImage {
//             imgUrl {
//               bucket
//               key
//               region
//             }
//             areas {
//               coords
//               lineWidth
//               name
//               preFillColor
//               shape
//             }
//           }
//         }
//       }
//     }
//   }
//   # {
//   #   "typeValue": "global::template"
//   # }
// `;

const listFormTemplates = gql`
query listFormTemplates( $typeValue: String! $limit: Int $nextToken: String){
  listFormTemplates(typeValue: $typeValue limit: $limit nextToken: $nextToken){
    items{
      id
      uId
      typeValue
      slugValue
      templateName
      templateType
      displayName
      # subTemplate
      # questionRefs
      keywords
      # speciality
      # subSpeciality
      templateDesignJson
      # templateRows{
      #   title
      #   addColumns
      #   templateColumns{
      #     title
      #     addSection
      #     columnSections{
      #       title
      #       isEditing
      #       secQuestions{
      #         slugValue
      #         queConditions{
      #           key
      #           conditonValue{
      #             quesSlug
      #             response
      #           }
      #           childrens{
      #             key
      #             conditonValue{
      #               quesSlug
      #               response
      #             }
      #           }
      #         }
      #       }
      #     }
      #   }
      # }
        active
        createdAt
        updatedAt
        createdBy
        updatedBy
        # uId
        # attachedQuestionRefs {
        #   id
        #   typeValue
        #   slugValue
        #   questionTitle
        #   questionType
        #   uId
        #   ageFrom
        #   ageTo
        #   appliedFor
        #   createdAt
        #   updatedAt
        #   active
        #   isRequired
        #   freeText {
        #     answerSummary
        #     freeTextRequired
        #     textInputType
        #   }
        #   number {
        #     answerSummary
        #     freeTextRequired
        #   }
        #   date {
        #     answerSummary
        #     freeTextRequired
        #   }
        #   file {
        #     answerSummary
        #     freeTextRequired
        #   }
        #   radioList {
        #     optionTitle
        #     optionSummary
        #     freeTextRequired
        #   }
        #   checkboxList {
        #     optionTitle
        #     optionSummary
        #     freeTextRequired
        #   }
        # fillInBlanks{ 
        #   answerSummary  
        # } 
        #   refImage {
        #     imgUrl {
        #       bucket
        #       key
        #       region
        #     }
        #     areas {
        #       coords
        #       lineWidth
        #       name
        #       preFillColor
        #       shape
        #     }
        #   }
        #   tableValues
        # }
    }
    nextToken
    }
  }
  # {
  #   "typeValue": "global::template"
  # }
`;
const listSectionTemplates = gql`
  query listSectionTemplates($typeValue: String!) {
    listSectionTemplates(typeValue: $typeValue) {
      id
      typeValue
      slugValue
      sectionName
      questionRefs
      active
      createdAt
      updatedAt
      attachedQuestions {
        id
        typeValue
        slugValue
        questionTitle
        questionType
        helpText
        uId
        ageFrom
        ageTo
        appliedFor
        createdAt
        updatedAt
        active
        isRequired
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
      }
    }
  }
  # {
  #   "typeValue": "global::section"
  # }
`;

const listQuestionTemplates = gql`
  query listQuestionTemplates($typeValue: String!, $limit: Int, $nextToken: String) {
    listQuestionTemplates(typeValue: $typeValue, limit: $limit, nextToken: $nextToken) {
      items{
        id
        typeValue
        slugValue
        questionTitle
        questionType
        helpText
        uId
        ageFrom
        ageTo
        appliedFor
        createdAt
        updatedAt
        active
        isRequired
        searchField
        freeText {
          answerSummary
          freeTextRequired
          textInputType
        }
        number {
          answerSummary
          freeTextRequired
        }
        date {
          answerSummary
          freeTextRequired
        }
        file {
          answerSummary
          freeTextRequired
        }
        radioList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        checkboxList {
          optionTitle
          optionSummary
          freeTextRequired
        }
        fillInBlanks{ 
          answerSummary  
          blanksType
          {
            type
            values
          }
        } 
        refImage {
          imgUrl {
            bucket
            key
            region
          }
          areas {
            coords
            lineWidth
            name
            preFillColor
            shape
          }
        }
        tableValues
        radioDisplayType
      }
      nextToken
    }
  }
  # {
  #   "patientId": "sohel::khan::male::1994-10-28",
  #   "apptId": "khan.sohel005@gmail.com::2020-MAY-04::10:00"
  # }
`;

const listUnitsByOrg = gql`
  query listUnitsByOrg($fqdn: String!) {
    listUnitsByOrg(fqdn: $fqdn) {
      id
      fqdn
      unitName
      unitId
      orgId
      email
      contactNo
      pharmacyLicenseNo
      clinicRegiNo
      shopEstNo
      tradeNo
      isActive
      skypeId
      createdAt
      updatedAt
      logo {
        bucket
        region
        key
      }
      address {
        use
        type
        lineOne
        lineTwo
        city
        state
        zip
        country
      }
    }
  }
  # {
  #   "fqdn": "unit::clinivantage.pms.com"
  # }
`;

const listDevicesByOrg = gql`
  query listDevicesByOrg($orgId: String!) {
    listDevicesByOrg(orgId: $orgId) {
      id
      orgId
      deviceId
      physicalId
      deployedAt
      active
      deviceType
      categories {
        category
        active
        tests {
          text
          deviceName
          value
          rate
          url {
            key
            bucket
            region
          }
          refImage{
              bucket
              region
              key
            }
          enabled
          active
        }
      }
    }
  }
`;
